import { render, staticRenderFns } from "./BizBusinessinfoCompleteModal.vue?vue&type=template&id=5f6973a5&"
import script from "./BizBusinessinfoCompleteModal.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoCompleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports